import { render } from "./Impressum.vue?vue&type=template&id=d1ecf912&bindings={\"text\":\"data\",\"srcTextText\":\"data\",\"srcImgText\":\"data\",\"srcIlluText\":\"data\"}"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"

import "./Impressum.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script